import { ActiveDetails } from '../components/organisms/ActiveDetails/ActiveDetails';

export default function DocumentsPage(): JSX.Element {
  return <ActiveDetails title="Detalhamento de Ativo Operacional" />;
}
